import {Component, OnInit} from '@angular/core';
import {User} from '../../data/models/user';
import {MatDialog} from '@angular/material/dialog';
import {MeService} from '../../services/api/me.service';
import {MeChangePasswordDialogComponent} from '../../components/dialogs/me-change-password-dialog/me-change-password-dialog.component';

@Component({
  selector: 'app-me-page',
  templateUrl: './me-page.component.html',
  styleUrls: ['./me-page.component.css']
})
export class MePageComponent implements OnInit {

  user!: User;

  constructor(
    private dialog: MatDialog,
    private meService: MeService,
  ) {
  }

  ngOnInit(): void {
    this.meService.fetchMe()
      .then(user => {
        if (user) {
          this.user = user;
        }
      });
  }

  formatFullFio(): string {
    let fio = '';
    if (this.user) {
      if (this.user.surname) {
        fio = this.user.surname;
      }
      if (this.user.name && this.user.name.length > 0) {
        if (fio.length > 0) {
          fio += ' ';
        }
        fio += this.user.name;
      }
      if (this.user.patronymic && this.user.patronymic.length > 0) {
        if (fio.length > 0) {
          fio += ' ';
        }
        fio += this.user.patronymic;
      }

    }
    return fio;
  }

  formatRoles(): string {
    if (this.user) {
      return this.user?.roles.map(r => r.name).join(', ');
    }
    return '';
  }

  openMeChangePasswordDialog(): void {
    const dialogRef = this.dialog.open(MeChangePasswordDialogComponent, {
      width: '90vw',
      maxWidth: '400px',
      data: {
        user: this.user
      }
    });

    dialogRef.afterClosed().subscribe(user => {
      if (user) {
        this.user = user;
      }
    });
  }

}
